import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Header from './components/header';
import Footer from './components/footer';
import Home from './components/Home';
import Blog from './components/Blog';
import BlogPost from './components/BlogPost';
import Contact from './components/Contact';
import MetaTags from './components/MetaTags';
import SchemaMarkup from './components/SchemaMarkup';
import ErrorBoundary from './components/ErrorBoundary';

function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();
  // Only the home page runs its hero up behind the fixed nav.
  const hasDarkHero = location.pathname === '/';

  const handleNavClick = (e, targetId) => {
    e.preventDefault();

    if (window.location.pathname !== '/') {
      navigate('/', { replace: false });
    }

    setTimeout(() => {
      const target = document.getElementById(targetId);
      if (target) {
        const yOffset = -100;
        const yPosition = target.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: yPosition, behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className={`ak-shell ${hasDarkHero ? 'has-dark-hero' : ''}`.trim()}>
      <Header handleNavClick={handleNavClick} />
      <ErrorBoundary>
        <Routes>
          {/*
            showLogoBar / showWork / showTestimonial stay off until there is
            real content for them — the design ships those three sections with
            placeholder logos, case studies, and a placeholder quote.
            processStyle: "terminal" | "plain".
          */}
          <Route
            path="/"
            element={
              <Home
                showLogoBar={false}
                showWork={false}
                showTestimonial={false}
                processStyle="terminal"
              />
            }
          />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </ErrorBoundary>
      <Footer handleNavClick={handleNavClick} />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <MetaTags
        title="Akeyreu — AI consulting & custom software for small business"
        description="We help small businesses find where AI actually helps, then build the software that runs it. Free 30-minute assessment. Plain language. Fixed scope."
        keywords="AI consulting, small business AI, workflow automation, custom software development, web and mobile apps, AI readiness review"
        canonicalUrl="https://www.akeyreu.com/"
      />

      <SchemaMarkup type="organization" />
      <SchemaMarkup type="website" />

      <Router>
        <AppContent />
      </Router>
    </HelmetProvider>
  );
}

export default App;
